export default {
  UP: 38,
  DOWN: 40,
  ESC: 27,
  ENTER: 13
};
